var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model &&
    _vm.model.lisReport.pageDatas &&
    _vm.model.lisReport.pageDatas.length > 0
    ? _c("div", { style: { height: _vm.model.isPage ? "620mm" : "310mm" } }, [
        _c(
          "div",
          { staticClass: "lisReport-page", attrs: { id: "print_lisReport" } },
          _vm._l(_vm.model.lisReport.pageDatas, function (pageItem, pageIndex) {
            return _c(
              "div",
              { staticClass: "page" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "font-size": "23px",
                      "text-align": "center",
                      "font-weight": "600",
                    },
                  },
                  [
                    _c(
                      "table",
                      {
                        staticStyle: {
                          width: "100%",
                          "border-collapse": "collapse",
                          border: "none",
                          "letter-spacing": "5px",
                        },
                      },
                      [
                        _c("tbody", [
                          _c(
                            "tr",
                            {
                              staticStyle: {
                                width: "100%",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "border-collapse": "collapse",
                                    border: "none",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.model.lisReport.hospitalName
                                        ? _vm.model.lisReport.hospitalName
                                        : ""
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "tr",
                            {
                              staticStyle: {
                                width: "100%",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "border-collapse": "collapse",
                                    border: "none",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.model.lisReport.reportName
                                        ? _vm.model.lisReport.reportName
                                        : ""
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c("div", [
                      _c("div", [
                        _c("img", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: { src: _vm.model.lisReport.barCodeImage },
                        }),
                      ]),
                      _vm.model.lisReport.barCodeImage
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "0px",
                                "font-size": "15px",
                                "letter-spacing": "0px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.model.lisReport.barCode))]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c(
                  "table",
                  {
                    staticStyle: {
                      "text-align": "left",
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "margin-top": "10px",
                      "border-bottom": "2px solid rgb(14, 14, 14)",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            "line-height": "25px",
                            width: "100%",
                            "border-collapse": "collapse",
                            "text-align": "left",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                "姓名：" +
                                  _vm._s(
                                    _vm.model.lisReport.name
                                      ? _vm.model.lisReport.name
                                      : ""
                                  )
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                "性别：" +
                                  _vm._s(
                                    _vm.model.lisReport.sex
                                      ? _vm.model.lisReport.sex
                                      : ""
                                  )
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                "年龄：" +
                                  _vm._s(
                                    _vm.model.lisReport.age
                                      ? _vm.model.lisReport.age
                                      : ""
                                  )
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                                width: "125px",
                              },
                            },
                            [
                              _vm._v(
                                "送检时间：" +
                                  _vm._s(
                                    _vm.model.lisReport.sendTime
                                      ? _vm.model.lisReport.sendTime
                                      : ""
                                  )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            "line-height": "25px",
                            width: "100%",
                            "border-collapse": "collapse",
                            "text-align": "left",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                              attrs: { colspan: "2" },
                            },
                            [
                              _vm._v(
                                "学校：" +
                                  _vm._s(
                                    _vm.model.lisReport.schoolName
                                      ? _vm.model.lisReport.schoolName
                                      : ""
                                  )
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                "年级：" +
                                  _vm._s(
                                    _vm.model.lisReport.gradeName
                                      ? _vm.model.lisReport.gradeName
                                      : ""
                                  )
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "100px",
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                "班级：" +
                                  _vm._s(
                                    _vm.model.lisReport.className
                                      ? _vm.model.lisReport.className
                                      : ""
                                  )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._l(
                  pageItem.lisProjectGroups,
                  function (groupItem, groupIndex) {
                    return pageItem.lisProjectGroups &&
                      pageItem.lisProjectGroups.length > 0
                      ? _c(
                          "table",
                          {
                            staticStyle: {
                              "text-align": "left",
                              "margin-top": "10px",
                              width: "100%",
                              "border-collapse": "collapse",
                              border: "none",
                              "border-bottom": "2px solid rgb(14, 14, 14)",
                            },
                          },
                          [
                            _c(
                              "tbody",
                              [
                                _c(
                                  "tr",
                                  {
                                    staticStyle: {
                                      "font-size": "18px",
                                      "border-collapse": "collapse",
                                      "text-align": "center",
                                      border: "none",
                                      "border-bottom":
                                        "1px solid rgb(14, 14, 14)",
                                      "font-weight": "600",
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "border-collapse": "collapse",
                                          border: "none",
                                        },
                                        attrs: { colspan: "5" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            groupItem.groupName
                                              ? "【" +
                                                  groupItem.groupName +
                                                  "】"
                                              : ""
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._m(0, true),
                                _vm._l(
                                  groupItem.children,
                                  function (childrenItem, childrenIndex) {
                                    return _c(
                                      "tr",
                                      {
                                        class:
                                          childrenIndex % 2 === 0
                                            ? ""
                                            : "tr-background",
                                        style: {
                                          "line-height": "20px",
                                          border: "none",
                                          "background-color":
                                            childrenIndex % 2 === 0
                                              ? ""
                                              : "rgba(166, 161, 161, 0.12)",
                                        },
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              width: "35%",
                                              "border-collapse": "collapse",
                                              border: "none",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(childrenItem.itemName)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              width: "10%",
                                              "border-collapse": "collapse",
                                              border: "none",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(childrenItem.itemValue)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              width: "10%",
                                              "border-collapse": "collapse",
                                              border: "none",
                                            },
                                          },
                                          [_vm._v(_vm._s(childrenItem.unit))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              width: "10%",
                                              "border-collapse": "collapse",
                                              border: "none",
                                            },
                                          },
                                          [_vm._v(_vm._s(childrenItem.notice))]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "border-collapse": "collapse",
                                              border: "none",
                                            },
                                          },
                                          [_vm._v(_vm._s(childrenItem.ranges))]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _c("tr", {
                                  staticStyle: {
                                    height: "10px",
                                    "border-collapse": "collapse",
                                    border: "none",
                                  },
                                }),
                                _c(
                                  "tr",
                                  {
                                    staticStyle: {
                                      border: "none",
                                      "border-top":
                                        "1px dashed rgb(14, 14, 14)",
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "border-collapse": "collapse",
                                          border: "none",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "检验人:" +
                                            _vm._s(groupItem.submitter)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "border-collapse": "collapse",
                                          border: "none",
                                        },
                                        attrs: { colspan: "3" },
                                      },
                                      [
                                        _vm._v(
                                          "审核人:" + _vm._s(groupItem.auditor)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "border-collapse": "collapse",
                                          border: "none",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "报告时间:" +
                                            _vm._s(groupItem.recordTime)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e()
                  }
                ),
                _vm._m(1, true),
              ],
              2
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticClass: "item-title",
        staticStyle: {
          "line-height": "20px",
          border: "none",
          "background-color": "#ddd",
          "font-weight": "600",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: {
              width: "35%",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("项目明细")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "10%",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "10%",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("单位")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "10%",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("提示")]
        ),
        _c(
          "td",
          { staticStyle: { "border-collapse": "collapse", border: "none" } },
          [_vm._v("参考范围")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticStyle: {
          width: "100%",
          "border-collapse": "collapse",
          border: "none",
          "text-align": "center",
        },
      },
      [
        _c("tbody", [
          _c("tr", { staticStyle: { border: "none" } }, [
            _c(
              "td",
              {
                staticStyle: {
                  "text-indent": "2ch",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [_vm._v("- 此报告结果仅对本次送检样本负责，结果仅供以上参考 -")]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }